module.exports = __webpack_public_path__ + "img/no-data.751fda8c.png";